import { Box } from "@mui/material";
import styled from "styled-components";

export const Appointments = styled(Box)`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  .appointment-card {
    flex-basis: calc((100% - 40px) / 3);
  }
  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 50vh;
    flex-direction: column;
    p {
      margin: 0;
    }
  }
  @media (max-width: 1024px) {
    .appointment-card {
      flex-basis: calc((100% - 20px) / 2);
    }
  }

  @media (max-width: 768px) {
    .appointment-card {
      flex-basis: 100%;
    }
  }
`;

export const DashboardStyled = styled(Box)`
  height: 100%;
  width: 100%;
  @media (max-width: 768px) {
    .title {
      font-size: 24px !important;
    }
  }
  @media (max-width: 576px) {
    .title {
      font-size: 16px !important;
    }
  }
`;

export const StyledTabs = styled(Box)(({ theme }) => ({
  "&.main-wrapper": {
    width: "100%",
  },
  ".MuiTabs-flexContainer": {
    borderBottom: "none !important",
  },
  ".MuiTab-root": {
    textTransform: "none",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    padding: "8px 16px",
    color: theme.palette.secondary.main,
    border: "1px solid transparent",
    borderRadius: "24px",
    minWidth: "200px",
    backgroundColor: theme.palette.common.white,
    transition: "all 0.3s ease",

    "&.Mui-selected": {
      color: theme.palette.primary.main,
      border: `1px solid var(--royal-blue-color)`,
    },

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  ".MuiTabs-indicator": {
    display: "none",
  },
  [`@media (max-width:${theme.breakpoints.values.sm}px)`]: {
    ".MuiTab-root": {
      minWidth: "120px !important",
      fontSize: "13px !important",
    },
    ".text-btn": {
      display: "none",
    },
    ".icon-btn": {
      display: "block",
      ".MuiButton-startIcon": {
        margin: "-2px !important",
      },
    },
  },
}));

export const SkeletonLoaderStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  .skeleton-item {
    margin-bottom: 16px;
    width: inherit;
  }
`;
